"use client";

import { createContext, useContext, useEffect, useMemo, useState } from "react";

import { listenForegroundMessages } from "./message";

const NotificationContext = createContext(null);

export function NotificationProvider({ children }) {
  const [last, setLast] = useState(null);
  const [items, setItems] = useState([]);

  useEffect(() => {
    const unsubscribe = listenForegroundMessages((data) => {
      setLast(data);
      setItems((prev) => [data, ...prev].slice(0, 50)); // guarda até 50
    });

    return () => unsubscribe();
  }, []);

  const value = useMemo(() => ({ last, items }), [last, items]);

  return (
    <NotificationContext.Provider value={value}>
      {children}
      <ForegroundToast last={last} />
    </NotificationContext.Provider>
  );
}

export function useNotifications() {
  const ctx = useContext(NotificationContext);
  if (!ctx) throw new Error("useNotifications deve ser usado dentro do NotificationProvider");
  return ctx;
}

function ForegroundToast({ last }) {
    const [visible, setVisible] = useState(false);
  
    useEffect(() => {
      if (!last) return;
  
      setVisible(true);
  
      const timer = setTimeout(() => {
        setVisible(false);
      }, 10000); // ⏱️ 10 segundos
  
      return () => clearTimeout(timer);
    }, [last]);
  
    if (!last) return null;
  
    return (
      <div
        style={{
          position: "fixed",
          top: 16,
          left: "50%",
          transform: `translateX(-50%) translateY(${visible ? "0" : "-16px"})`,
          opacity: visible ? 1 : 0,
          width: "min(520px, 92vw)",
          zIndex: 999999,
          background: "#fff",
          borderRadius: 14,
          boxShadow: "0 14px 40px rgba(0,0,0,.18)",
          padding: "14px 16px",
          border: "1px solid rgba(0,0,0,.08)",
          transition: "all .28s ease",
          cursor: "pointer",
        }}
        onClick={() => {
          const url = last?.payload?.data?.url;
          if (url) window.location.href = url;
        }}
        role="button"
        tabIndex={0}
      >
        <div style={{ fontWeight: 900, fontSize: 15, marginBottom: 4 }}>
          {last.title}
        </div>
        <div style={{ fontSize: 13, opacity: 0.85 }}>
          {last.body}
        </div>
      </div>
    );
  }
  
